import styled from 'styled-components';

export const Container = styled.div`
  width: 800px;
  border-radius: 20px;
  padding: 2em;
  border-radius: 20px;
  height: 620px;
  z-index: 2;
  background: var(--surface-1);
  color: var(--text-primary);
  border: 1px solid var(--border-subtle);
  box-shadow: var(--shadow-md);

  h3 {
    color: var(--text-heading);
  }

  @media (max-width: 768px) {
    width: 90vw;
    height: auto;
    padding: 1em;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  max-width: 600px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  margin-bottom: 10px;
  font-weight: 700;
`;

export const Input = styled.input`
  padding: 10px;
  margin-bottom: 20px;
  border: 2px solid var(--border-default);
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
  }
`;

export const Span = styled.span`
  color: var(--text-secondary);
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

export const Button = styled.button`
  border-radius: 8px;
  padding: 16px;
  width: 80%;
  margin: 0 auto 8px auto;
  background: var(--accent);
  color: var(--text-on-accent);
  font-size: 16px;
`;

export const ButtonSecondary = styled.button`
  border-radius: 8px;
  padding: 16px;
  width: 80%;
  margin: 0 auto 8px auto;
  background: transparent;
  border: 1px solid var(--accent);
  color: var(--accent);
  font-size: 16px;
`;


export const StyledFileInput = styled.input`

  /* Styling for the custom button */
  label {
    display: inline-block;
    padding: 10px 20px;
    background-color: var(--accent);
    color: var(--text-on-accent);
    cursor: pointer;
  }
`;
